import { render } from "./StaffDatatableAssistantActions.vue?vue&type=template&id=e399dadc"
import script from "./StaffDatatableAssistantActions.vue?vue&type=script&lang=js"
export * from "./StaffDatatableAssistantActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__